import styled from "styled-components";
import {UserMenuSeparatorDefaultBox} from "./user-menu-separator.default.box";
import {baseColors} from "../../../../../themes/definitions/mrgreen/base-colors";

export const UserMenuSeparatorMrGreenBox = styled(UserMenuSeparatorDefaultBox)`
  background-color: ${baseColors.gray233};
  opacity: 0.2;
`